import type { DependencyList, EffectCallback } from "react";
import { useRef, useEffect } from "react";

export const useDidUpdate = (callback: EffectCallback, dependencies?: DependencyList): void => {
    const hasMountedRef = useRef(false);

    useEffect(() => {
        if (hasMountedRef.current) {
            return callback();
        } else {
            hasMountedRef.current = true;
        }
    }, dependencies);
};
